import clsx from "clsx";
import { ChangeEvent } from "react";

import "./styles.css";

interface Props {
  id: string;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  selected?: boolean;
  className?: string;
  onChange: (e: ChangeEvent) => void;
}

export const InputCheckboxWithoutControl = ({
  id,
  label,
  ariaLabel,
  disabled,
  selected = false,
  className,
  onChange,
}: Props): JSX.Element => {
  return (
    <div className={clsx("input-checkbox-without-control flex w-fit flex-col", className)}>
      <label
        htmlFor={id}
        className={clsx(
          "options-label relative min-h-[20px]",
          disabled ? "opacity-50" : "cursor-pointer",
          label ? "pl-6" : "pl-[18px]",
          { selected, disabled },
        )}
      >
        {label}
      </label>

      <input
        id={id}
        className="m-0 h-0 w-0 opacity-0"
        type="checkbox"
        aria-label={ariaLabel}
        disabled={disabled}
        checked={selected}
        onChange={onChange}
      />
    </div>
  );
};
